var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_76688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75861 9.4132C1.85705 8.51164 1.40627 8.06086 1.23853 7.47601C1.0708 6.89115 1.21415 6.26998 1.50084 5.02763L1.66617 4.31119C1.90737 3.26599 2.02797 2.74339 2.38583 2.38553C2.7437 2.02767 3.26629 1.90707 4.31149 1.66587L5.02793 1.50054C6.27028 1.21384 6.89146 1.07049 7.47631 1.23823C8.06117 1.40596 8.51195 1.85674 9.41351 2.7583L10.4808 3.82559C12.0494 5.39417 12.8337 6.17845 12.8337 7.15304C12.8337 8.12763 12.0494 8.91192 10.4808 10.4805C8.91222 12.0491 8.12793 12.8334 7.15335 12.8334C6.17876 12.8334 5.39447 12.0491 3.8259 10.4805L2.75861 9.4132Z",
    stroke: "#34265c",
    strokeWidth: 0.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97726 8.9771C9.31897 8.63539 9.36514 8.12754 9.08038 7.84278C8.79563 7.55803 8.28777 7.60419 7.94607 7.9459C7.60436 8.28761 7.09651 8.33378 6.81175 8.04902C6.52699 7.76426 6.57316 7.25641 6.91487 6.91471M8.97726 8.9771L9.1835 9.18334M8.97726 8.9771C8.74335 9.21101 8.43159 9.30644 8.16683 9.25203M6.70863 6.70847L6.91487 6.91471M6.91487 6.91471C7.10808 6.72149 7.35441 6.62277 7.5835 6.62493",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.02101,
    cy: 5.17947,
    r: 1.16667,
    transform: "rotate(-45 5.02101 5.17947)",
    stroke: "#34265c",
    strokeWidth: 0.875
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_76688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellation);
export default __webpack_public_path__ + "static/media/Cancellation.8b73e1298ae4fe85920d5e9453707570.svg";
export { ForwardRef as ReactComponent };